import {
    HStack,
    Text,
    useFilter,
    useListCollection,
    Combobox,
    Icon
} from "@chakra-ui/react";
import MentionField from "@/pages/scenario/components/MentionField";
import {LuChevronDown, LuTrash} from "react-icons/lu";
import {useEffect, useState} from "react";
import {HiOutlineTrash} from "react-icons/hi2";
import MentionTextArea from "@/pages/scenario/components/MentionTextArea";

const ConditionalField = ({value, onChange, entities, intents, index, onRemoveClick, canDelete}) => {
    const {contains} = useFilter({sensitivity: "base"})
    const [transition, setTransition] = useState(value ? value : {destination: "", condition: ""});

    const {collection, filter} = useListCollection({
        initialItems: intents?.map(item => ({label: item.name, value: item.name})),
        filter: contains,
    })

    useEffect(() => {
        console.log('[ConditionalField] 🚀 ', JSON.stringify(entities, null, 2));
    }, [entities]);

    useEffect(() => {
        onChange(transition, index)
    }, [transition]);

    const handleChangeDestination = (value) => {
        setTransition(prev => ({
            ...prev,
            destination: value[0] ?? ""
        }))
    }

    const handleChangeCondition = (value) => {
        setTransition(prev => ({
            ...prev,
            condition: value
        }))
    }

    const handleRemoveClick = () => {
        onRemoveClick(value.id)
    }

    return (
        <HStack w={'full'}>
            <HStack w={'full'} justifyContent={'space-between'} p={4} bg={'#2F2F2F'} borderRadius={8} gap={4}
                    position={'relative'}>
                <Text color={'white'} fontSize={18} fontWeight={400} textWrap={'nowrap'}>Go to</Text>
                <Combobox.Root
                    openOnClick
                    onValueChange={(e) => handleChangeDestination(e.value)}
                    value={[transition.destination]}
                    flex={1}
                    variant="ghosty"
                    collection={collection}
                    positioning={{strategy: "fixed", hideWhenDetached: true}}
                    onInputValueChange={(e) => filter(e.inputValue)}
                >
                    <Combobox.Control>
                        <Combobox.Input placeholder="Type to search"/>
                        <Combobox.IndicatorGroup>
                            <Combobox.ClearTrigger color={'gray.600'}/>
                            <Combobox.Trigger pr={1}>
                                <Icon size={"lg"} color={'white'}>
                                    <LuChevronDown/>
                                </Icon>
                            </Combobox.Trigger>
                        </Combobox.IndicatorGroup>
                    </Combobox.Control>
                    <Combobox.Positioner>
                        <Combobox.Content>
                            <Combobox.Empty color={'gray.500'}>No items found</Combobox.Empty>
                            {collection.items?.map((item) => (
                                <Combobox.Item item={item} key={item.value}>
                                    {item.label}
                                    <Combobox.ItemIndicator/>
                                </Combobox.Item>
                            ))}
                        </Combobox.Content>
                    </Combobox.Positioner>
                </Combobox.Root>
                <Text color={'white'} fontSize={18}>if</Text>

                <MentionField
                    contentContainerProps={{flex: 2}}
                    onChange={handleChangeCondition}
                    value={transition.condition}
                    mentionSets={[{
                        variables: entities,
                        wakeUpChar: '@',
                        filterKey: 'id',
                        selectKey: 'id',
                        showProvider: true,
                    }]}
                    variant={'dark'}
                    placeholder={'Describe the condition that must be met'}
                />
            </HStack>
            {canDelete &&
                <Icon size={"md"} color={'gray.500'} ml={2} cursor={'pointer'} onClick={handleRemoveClick}>
                    <HiOutlineTrash />
                </Icon>
            }
        </HStack>
    )
}

export default ConditionalField;

const frameworks = [
    {label: "React", value: "react"},
    {label: "Solid", value: "solid"},
    {label: "Vue", value: "vue"},
    {label: "Angular", value: "angular"},
    {label: "Svelte", value: "svelte"},
    {label: "Preact", value: "preact"},
    {label: "Qwik", value: "qwik"},
    {label: "Lit", value: "lit"},
    {label: "Alpine.js", value: "alpinejs"},
    {label: "Ember", value: "ember"},
    {label: "Next.js", value: "nextjs"},
]